import { updateKeyInStore } from 'App';
import {
  SoleProprietorshipform1099MiscAnd1099NecStateValues,
  updateKey,
} from '../slice';

export const uploadFields:
  | IBaseField<keyof SoleProprietorshipform1099MiscAnd1099NecStateValues>
  | {}[] = [
  {
    name: 'pleaseUpload1099s',
    label: 'Please upload 1099s',
    type: 'upload',
    effect: updateKeyInStore(updateKey),
    predicate: (v: string) => !!v && Number(v) > 0,
    dependentOn:
      'taxQuestionnaire.soleProprietorship.soleProprietorshipForm1099MISCand1099NEC.values.howManyForms1099MiscOr1099NecIssuesToTheNameOfYourBusinessDidYouReceiveThisYear',
    comment: true,
  },
];
